import { DateTime } from 'luxon';

export const ET_TIMEZONE = 'America/New_York';

export const getDefaultSearchDates = () => {
  // The Trading Dash loses games completely once we roll over midnight;
  // As such, setting fromDate to "yesterday" keeps current projections accessible
  const fromDate = DateTime.now().minus({ days: 1 }).toISODate();
  const toDate = DateTime.now().plus({ days: 30 }).toISODate();

  return { fromDate, toDate };
};

export const formatWithTimezoneChange = (
  date: DateTime,
  pattern: string
): string => {
  return date.toFormat(pattern).replace(/(EST|EDT)/g, 'ET');
};

export const isTimeBefore = ({
  dateValue,
  dateToCompareAgainst = DateTime.now()
}: {
  dateValue: DateTime;
  dateToCompareAgainst?: DateTime;
}): boolean => dateValue <= dateToCompareAgainst;

export const isTimeAfter = ({
  dateValue,
  dateToCompareAgainst = DateTime.now()
}: {
  dateValue: DateTime;
  dateToCompareAgainst?: DateTime;
}): boolean => dateValue >= dateToCompareAgainst;

export const isTimeAfterEST = (
  dateValue: string,
  dateToCompareAgainst: DateTime = DateTime.now().setZone(ET_TIMEZONE)
): boolean => {
  const date = DateTime.fromISO(dateValue, { zone: ET_TIMEZONE });
  return date <= dateToCompareAgainst;
};

export const isTimeEqual = ({
  dateValue,
  dateToCompareAgainst = DateTime.now()
}: {
  dateValue: DateTime;
  dateToCompareAgainst?: DateTime;
}): boolean => dateValue.toMillis() === dateToCompareAgainst.toMillis();

export const isTimeWithinInterval = ({
  end,
  start,
  time
}: {
  end: DateTime;
  start: DateTime;
  time: DateTime;
}): boolean =>
  isTimeAfter({ dateValue: time, dateToCompareAgainst: start }) &&
  isTimeBefore({ dateValue: time, dateToCompareAgainst: end });

export const getPaymentsDateTime = (date: string): DateTime => {
  return DateTime.fromFormat(date, 'yyyy-LL-dd HH:mm:ss ZZZ');
};

export const getAutomtatedTestDateTime = () =>
  DateTime.fromFormat('15:00', 'HH:mm', {
    zone: 'America/New_York'
  })
    .plus({ days: 1 })
    .toUTC()
    .toString();

export const getAutomatedTestProjectionDateTime = () => {
  const currenETDate = DateTime.fromFormat('15:00', 'HH:mm', {
    zone: 'America/New_York'
  });

  return {
    futureDate: currenETDate.plus({ days: 1 }).toFormat('MM/dd/yyyy hh:mm a'),
    pastDate: currenETDate.minus({ days: 1 }).toFormat('MM/dd/yyyy hh:mm a')
  };
};

export const isValidDate = (date: Date | undefined): boolean => {
  return date instanceof Date && !Number.isNaN(date.getTime());
};
